import { createFileRoute } from "@tanstack/react-router"
import { OAuthResult } from "@/app"

export const Route = createFileRoute("/oauth-result")({
  component: RouteComponent,
  validateSearch: (search) =>
    search as {
      result: "success" | "error" | "cancelled"
      refreshToken?: string
      error?: string
      state?: string
    },
})

function RouteComponent() {
  const { result, refreshToken, error, state } = Route.useSearch()

  return (
    <OAuthResult
      result={result}
      refreshToken={refreshToken}
      error={error}
      state={state}
    />
  )
}
